import { createFileRoute } from "@tanstack/react-router";
import { ProfileSection } from "@/features/dashboard/ProfileSection";

export const Route = createFileRoute("/_auth/_agents/settings/profile")({
  component: ProfileSection,
});
